import "./utilities_namespace.js";

// Prevent a function from being called more than once within the threshold

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

Sparkle.Utilities.geolocate = function () {
  const deferred = new jQuery.Deferred();
  if (!("geolocation" in navigator)) {
    return deferred.reject();
  }

  navigator.geolocation.getCurrentPosition(
    function (location) {
      // var location = { coords: { latitude: '13', longitude: '12' } } // DEBUG: For local testing where browsers refuse to geolocate on HTTP
      deferred.resolve(location);
    },
    function (error) {
      deferred.reject(error);
    },
  );

  return deferred.promise();
};
